import { type ReactNode } from "react";
import { Button } from "@/components/input/Button";

import {
  useWrapExperienceCardContext,
  type WrapExperienceCardProps,
} from "./WrapExperienceContext";

interface Props {
  children: ReactNode;
  onClick?: (card: WrapExperienceCardProps) => void;
}

const WrapExperienceButton = ({ children, onClick = () => null }: Props) => {
  const { card } = useWrapExperienceCardContext();

  function handleClick() {
    onClick(card);
  }
  return (
    <Button onClick={handleClick} className="flex w-full justify-center">
      {children}
    </Button>
  );
};

export default WrapExperienceButton;
